module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "results"
  }, [(_vm.value) ? _c('div', {
    staticClass: "ind"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.title),
      expression: "value.title"
    }],
    staticClass: "link",
    domProps: {
      "value": (_vm.value.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "title", $event.target.value)
      }
    }
  }), _c('br'), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("https://www.mamamia.com.au/" + _vm._s(_vm.slug) + " ▾")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.description),
      expression: "value.description"
    }],
    staticClass: "desc",
    attrs: {
      "type": "text",
      "placeholder": "Enter between 120 and 156 characters"
    },
    domProps: {
      "value": (_vm.value.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "description", $event.target.value)
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-333f2d60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/articleWidgets/GooglePreview.vue
// module id = 644
// module chunks = 1